import { render, staticRenderFns } from "./GeneralSalesScreen.vue?vue&type=template&id=e5087b90&scoped=true&"
import script from "./GeneralSalesScreen.vue?vue&type=script&lang=js&"
export * from "./GeneralSalesScreen.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSalesScreen.vue?vue&type=style&index=0&id=e5087b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5087b90",
  null
  
)

export default component.exports